'use strict';
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
var tree = document.querySelector('#tree');
function createTree(element, data) {
    for(var key in data){
        var newLi = document.createElement('li');
        newLi.textContent = "".concat(key);
        if (data[key] !== null && _type_of(data[key]) === 'object' && Object.keys(data[key]).length) {
            var newUl = document.createElement('ul');
            createTree(newUl, data[key]);
            newLi.append(newUl);
        }
        element.append(newLi);
    }
}
createTree(tree, food);

//# sourceMappingURL=js_tree-from-object-DOM.316c72fa.js.map
